module.exports = __webpack_public_path__ + "img/03.cb227dc.png";